export * from "ce/plugins/Linting/utils/getEntityUniqueIdForLogs";
import getEntityUniqueIdForLogs from "ce/plugins/Linting/utils/getEntityUniqueIdForLogs";

export default getEntityUniqueIdForLogs;
